import { Cookies } from 'react-cookie';

import { Encounter } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getObjectEncs = async (slug: string) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`api/v1/encounters/site/${slug}`, {
    headers: {
      Authorization: token,
    },
  });

  return data.data as Encounter[];
};
